/** Matches library grid: `repeat(auto-fill, minmax(140px, 1fr))` + 12px gap */
export const LIBRARY_GRID_COL_MIN_PX = 140;
export const LIBRARY_GRID_GAP_PX = 12;
export const LIBRARY_GRID_SPAN_MIN = 2;
export const LIBRARY_GRID_SPAN_MAX = 6;

/** Fixed layout width for URL / page-only stub pins (no real element capture). */
export const PAGE_ONLY_ELEMENT_WIDTH = 1200;

export function getCardGridSpan(elementWidth) {
  const parsed = Number(elementWidth);
  let span = Number.isFinite(parsed) && parsed > 0
    ? Math.ceil(parsed / 100 / 4)
    : LIBRARY_GRID_SPAN_MIN;
  if (span < LIBRARY_GRID_SPAN_MIN) span = LIBRARY_GRID_SPAN_MIN;
  if (span > LIBRARY_GRID_SPAN_MAX) span = LIBRARY_GRID_SPAN_MAX;
  return span;
}

/** Minimum width for a card spanning N grid columns (list view baseline). */
export function getCardWidthFromGridSpan(span) {
  return span * LIBRARY_GRID_COL_MIN_PX + (span - 1) * LIBRARY_GRID_GAP_PX;
}

export const PIN_CARD_MAX_WIDTH = getCardWidthFromGridSpan(LIBRARY_GRID_SPAN_MAX);

/** elementWidth at span 6 maps to max card width (matches list's widest column span). */
export const PIN_CARD_ELEMENT_WIDTH_REFERENCE = LIBRARY_GRID_SPAN_MAX * 400;
